import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

import GlobalNotifications from 'src/elements/GlobalNotifications';

const AuthLayout: FC = () => (
  <>
    <header>
      <nav className="navbar navbar-expand-md navbar-dark bg-dark text-white fs-6">
        GBMC Lit
        <span role="img" aria-label="lit" className="ml-2">
          🔥
        </span>
      </nav>
    </header>
    <main className="container-xl mt-4">
      <GlobalNotifications />
      <Outlet />
    </main>
  </>
);

export default AuthLayout;
